import { useContext } from 'react';
import { LanguageContext } from "../context/LanguageProvider";
import Questions from './Questions';
import { useMsal } from "@azure/msal-react";
import { useAuthenticatedApiFetch } from '../hooks/useAuthenticatedApiFetch';
import { usePayableAmount } from "../hooks/usePayableAmount";
import { formatAmount } from "../utils/formatUtils";

const POLICY_INFO = ({
  client,
  product,
  productId,
  subGroup,
  validationErrors,
  setValidationErrors,
  inputRefs,
  handleInputBlur,
  language,
  setQuestions,
  firstLevelArea,
  secondLevelArea,
  subArea,
  inputBlurTriggered,
  savingQuestionId,
  fetchAreaNames,
  setIsDataSaved
}) => {
  const { t } = useContext(LanguageContext);
  const { instance } = useMsal();  
  const authenticatedApiFetch = useAuthenticatedApiFetch(instance);
  const payableAmount = usePayableAmount(authenticatedApiFetch, product, productId, client);
  return (
    <div className="POLICY_INFO">
      <div className="questions">
        {subGroup.subAreaCompositionDtoList.map((question, index) => (
          <div key={question.uniqueId} className="question-wrapper">
            <div className="payable-amount">
                {question.label}
                {index === 0 && (
                  <>
                    {formatAmount(payableAmount, language)}<br /> <span>/ {t('month')}</span>
                  </>
                )}             
            </div>
            <Questions
              question={question}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              inputRefs={inputRefs}
              setQuestions={setQuestions}
              handleInputBlur={handleInputBlur}
              firstLevelArea={firstLevelArea}
              subArea={subArea}
              secondLevelArea={secondLevelArea}
              inputBlurTriggered={inputBlurTriggered}
              savingQuestionId={savingQuestionId}
              fetchAreaNames={fetchAreaNames}
              client={client}
              product={product}
              language={language}
              setIsDataSaved={setIsDataSaved}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default POLICY_INFO;
